export default "__VITE_ASSET__BqWVxcdh__"